// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "3.80.0/styles/" + (chunkId === 225 ? "videojs" : chunkId) + ".chunk.css?" + {"225":"0d3626fcfce32d1bf41a","753":"353faa143a2edd9cbb97"}[chunkId] + "";
};